import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import {
    CmsConfig,
    ConfigModule,
    FeaturesConfigModule,
    I18nModule,
    PageMetaResolver,
    ProductSearchService,
    UrlModule
} from '@spartacus/core';
import { ProductVariantsModule } from '@spartacus/product/variants';
import { CarouselModule, IconModule, ItemCounterModule, ListNavigationModule, MediaModule, OutletModule, ProductFacetService, SpinnerModule, StarRatingModule } from '@spartacus/storefront';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { SafePipeModule } from 'safe-pipe';
import { UigPipesModule } from 'src/app/pipes/uig-pipes.module';
import { UigAddToCartModule } from '../uig-cart/uig-add-to-cart/uig-add-to-cart.module';
import { UigCategoryPageMetaResolver } from './services/uig-category-page-meta.resolver';
import { UigProductFacetService } from './services/uig-product-facet-service';
import { UigProductPageMetaResolver } from './services/uig-product-page-meta.resolver';
import { UigProductSearchService } from './services/uig-product-search.service';
import { UigSearchPageMetaResolver } from './services/uig-search-page-meta.resolver';
import { UigAddToWishlistModule } from './uig-add-to-wishlist/uig-add-to-wishlist.module';
import { UigAvailabilityModule } from './uig-availability/uig-availability.module';
import { UigCampaignNoteComponent } from './uig-campaign-note/uig-campaign-note.component';
import { UigCampaignsIconsComponent } from './uig-campaigns-icons/uig-campaigns-icons.component';
import { UigMarketplaceIconModule } from './uig-marketplace-icon/uig-marketplace-icon.module';
import { UigProductDetailsContainerComponent } from './uig-product-details-container/uig-product-details-container.component';
import { UigProductIdentifiersComponent } from './uig-product-identifiers/uig-product-identifiers.component';
import { UigProductListComponent } from './uig-product-list/container/uig-product-list.component';
import { UigProductScrollComponent } from './uig-product-list/container/uig-product-scroll/uig-product-scroll.component';
import { UigProductSearchAdapter } from './uig-product-list/container/uig-product-search.adapter';
import { UigProductListItemComponent } from './uig-product-list/uig-product-list-item/uig-product-list-item.component';
import { UigProductManufacturerComponent } from './uig-product-manufacturer/uig-product-manufacturer.component';
import { UIGProductPriceCalculatorAdapter } from './uig-product-price-calculator/store/uig-product-price-calculator.adapter';
import { UIGProductPriceCalculatorEffects } from './uig-product-price-calculator/store/uig-product-price-calculator.effects';
import { updateProductPriceFeatureKey, updateProductPriceReducer } from './uig-product-price-calculator/store/uig-product-price-calculator.reducer';
import { UigProductPriceCalculatorComponent } from './uig-product-price-calculator/uig-product-price-calculator.component';
import { UigProductPricesComponent } from './uig-product-prices/uig-product-prices.component';
import { UigProductSummaryComponent } from './uig-product-summary/uig-product-summary.component';
import { UigPorductReferencesTabComponent } from './uig-product-tabs/uig-porduct-references-tab/uig-porduct-references-tab.component';
import { UigProductDetailsTabComponent } from './uig-product-tabs/uig-product-details-tab/uig-product-details-tab.component';
import { UigProductDownloadsTabComponent } from './uig-product-tabs/uig-product-downloads-tab/uig-product-downloads-tab.component';
import { UigProductNaturalRabattTabComponent } from './uig-product-tabs/uig-product-natural-rabatt-tab/uig-product-natural-rabatt-tab.component';
import { UigProductPriceSearchTabComponent } from './uig-product-tabs/uig-product-price-search-tab/uig-product-price-search-tab.component';
import { UigProductSetsTabComponent } from './uig-product-tabs/uig-product-sets-tab/uig-product-sets-tab.component';
import { UigProductVideoTabComponent } from './uig-product-tabs/uig-product-video-tab/uig-product-video-tab.component';
import './uig-product.models';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        MediaModule,
        ItemCounterModule,
        ListNavigationModule,
        UrlModule,
        I18nModule,
        StarRatingModule,
        IconModule,
        SpinnerModule,
        InfiniteScrollDirective,
        ProductVariantsModule,
        SafePipeModule,
        MediaModule,
        CarouselModule,
        FeaturesConfigModule,
        OutletModule,
        FormsModule,
        ReactiveFormsModule,
        UigAddToCartModule,
        UigAddToWishlistModule,
        UigAvailabilityModule,
        UigPipesModule,
        UigMarketplaceIconModule,
        ConfigModule.withConfig({
            cmsComponents: {
                SearchResultsListComponent: {
                    component: UigProductListComponent,
                },
                CMSProductListComponent: {
                    component: UigProductListComponent,
                },
                ProductGridComponent: {
                    component: UigProductListComponent,
                },
                ProductDetailsTabComponent: {
                    component: UigProductDetailsTabComponent,
                },
                ProductCampaignsIconsComponent: {
                    component: UigCampaignsIconsComponent,
                },
                ProductDownloadsTabComponent: {
                    component: UigProductDownloadsTabComponent,
                },
                ProductVideoTabComponent: {
                    component: UigProductVideoTabComponent,
                },
                ProductPriceSearchTabComponent: {
                    component: UigProductPriceSearchTabComponent,
                },
                ProductNaturalRabattTabComponent: {
                    component: UigProductNaturalRabattTabComponent,
                },
                ProductReferencesTabComponent: {
                    component: UigPorductReferencesTabComponent,
                },
                ProductSetsTabComponent: {
                    component: UigProductSetsTabComponent,
                },
                ProductManufacturerComponent: {
                    component: UigProductManufacturerComponent,
                },
                ProductIdentifiersComponent: {
                    component: UigProductIdentifiersComponent,
                },
                ProductPriceCalculatorComponent: {
                    component: UigProductPriceCalculatorComponent,
                },
                ProductPricesComponent: {
                    component: UigProductPricesComponent,
                },
                ProductCampaignNoteComponent: {
                    component: UigCampaignNoteComponent,
                },
                ProductDetailsContainerComponent: {
                    component: UigProductDetailsContainerComponent,
                },
            },
            backend: {
                occ: {
                    endpoints: {
                        productSearch: 'products/search?fields=products(code,name,summary,ean,manufacturer,campaignsTypes,marketingText1,mvgr2,mvgr3,ekPriceChange,ekPriceChangeDate,formattedEkPriceChangeDate,configurable,ekPrice(FULL),uvpPrice(FULL),images(DEFAULT),stock(FULL),vendor(DEFAULT),marketplace,rfuvpPrice(FULL)),facets,breadcrumbs,pagination(DEFAULT),sorts(DEFAULT),freeTextSearch,currentQuery',
                        product: {
                            details: 'products/${productCode}?fields=averageRating,minDecline,stock(DEFAULT),productReferencesTab(FULL),productReferences,description,imageTextShort,imageTextLong,marketingText1,marketingText2,videoLinks,naturalRabatt(FULL),priceSearchEngineUrls(FULL),dataSheets(FULL),dealerInformation(FULL),code,url,price(DEFAULT),manufacturer,categories(FULL),priceRange,multidimensional,tags,images(FULL),campaignsTypes,warrantyText,warrantyLink,ean,supplierArticleNumber,unserPrice(FULL),formattedUserCustomProfitMargin,bestPrice(FULL),formattedCalculatedProfitMargin,uvpPrice(FULL),discounts,ekPrice(FULL),mvgr2,mvgr3,dropShipmentExcluded,bulkyGoods,deliveryCostBulkyDirect(formattedValue),vendor,marketplace,manDistName,manDistLink,safetyName,safetyLink,rfuvpPrice(FULL),taxm1',
                        },
                        getCustomSalesPrice: '/customSalesPrice/getPrice',
                        updateCustomSalesPrice: '/customSalesPrice/updatePrice'
                    },
                },
            },
        } as CmsConfig),
        StoreModule.forFeature(updateProductPriceFeatureKey, updateProductPriceReducer),
        EffectsModule.forFeature([UIGProductPriceCalculatorEffects])
    ],
    providers: [
        {
            provide: UIGProductPriceCalculatorAdapter,
            useClass: UIGProductPriceCalculatorAdapter,
        },
        {
            provide: UigProductSearchAdapter,
            useClass: UigProductSearchAdapter,
        },
        {
            provide: PageMetaResolver,
            useClass: UigCategoryPageMetaResolver,
            multi: true,
        },
        {
            provide: PageMetaResolver,
            useClass: UigSearchPageMetaResolver,
            multi: true,
        },
        {
            provide: PageMetaResolver,
            useClass: UigProductPageMetaResolver,
            multi: true,
        },
        {
            provide: ProductFacetService,
            useClass: UigProductFacetService,
        },
        {
            provide: ProductSearchService,
            useClass: UigProductSearchService,
        }
    ],
    declarations: [
        UigProductListComponent,
        UigProductScrollComponent,
        UigProductListItemComponent,
        UigCampaignsIconsComponent,
        UigProductDetailsTabComponent,
        UigProductDownloadsTabComponent,
        UigProductVideoTabComponent,
        UigProductPriceSearchTabComponent,
        UigProductNaturalRabattTabComponent,
        UigPorductReferencesTabComponent,
        UigProductManufacturerComponent,
        UigProductIdentifiersComponent,
        UigPorductReferencesTabComponent,
        UigProductPriceCalculatorComponent,
        UigProductPricesComponent,
        UigCampaignNoteComponent,
        UigProductDetailsContainerComponent,
        UigProductSummaryComponent,
        UigProductSetsTabComponent
    ],
    exports: [UigProductListComponent, UigProductScrollComponent]
})
export class UigProductModule {
}
